import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { IndexList } from "./Common/IndexList";
import { useState } from "react";
import { ComparisonCard, ComparisonData } from "./Common/ComparisonCard";
import { ComparisonSelector } from "./ComparisonSelector";
import type { ComponentAppearance } from "src/components/appearance";

type SummaryLayoutProps = {
    items: ComparisonData[];
    unit?: string;
    appearance?: ComponentAppearance;
};
export const SummaryLayout = (props: SummaryLayoutProps) => {
    const { appearance = "legacy", items, unit = "" } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [selectedIndex, setSelectedIndex] = useState<string>(items[0].key);
    const selectedItem = items.find((i) => i?.title === selectedIndex);

    return (
        <Grid container spacing={2}>
            {!isMobile && (
                <Grid item xs={12} md={3}>
                    <IndexList
                        items={items}
                        selectedIndex={selectedIndex}
                        onClick={(newIndex) => {
                            setSelectedIndex(newIndex);
                        }}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={9}>
                <ComparisonCard
                    score={selectedItem}
                    unit={unit}
                    selectorComponent={
                        isMobile ?
                            <ComparisonSelector
                                appearance={appearance}
                                items={items}
                                selectedIndex={selectedIndex}
                                onChange={(newIndex) => {
                                    setSelectedIndex(newIndex);
                                }}
                            />
                        :   undefined
                    }
                />
            </Grid>
        </Grid>
    );
};
